/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Subject_French13Inputs */

const en__field_enum_subject_french13 = /** @type {(inputs: _Field_Enum_Subject_French13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`French`)
};

const de__field_enum_subject_french13 = /** @type {(inputs: _Field_Enum_Subject_French13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Französisch`)
};

/**
* | output |
* | --- |
* | "French" |
*
* @param {_Field_Enum_Subject_French13Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_subject_french13 = /** @type {((inputs?: _Field_Enum_Subject_French13Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Subject_French13Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_subject_french13(inputs)
	return de__field_enum_subject_french13(inputs)
});
export { _field_enum_subject_french13 as "_field_enum_SUBJECT_FRENCH" }